import { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { SiteContext } from '@interflora/ui-components/build/utils/common'
import { GET_CART } from 'graphql/queries'
import { DELIVERY_PASS_EXISTS_ERROR, DELIVERY_PASS_IN_CART_ERROR } from '../constants'

export const useDeliveryPassExists = () => {
  const { getCustomer } = useContext(SiteContext)
  const { data: cartData } = useQuery(GET_CART, { fetchPolicy: 'no-cache', ssr: false })

  const throwIfDeliveryPassExists = () => {
    const hasPassinAccount = !!getCustomer.data?.customer?.deliveryPass?.type
    const hasPassInCart = !!cartData?.cart?.deliveryPassType
    if (hasPassinAccount) {
      throw new Error(DELIVERY_PASS_EXISTS_ERROR)
    }
    if (hasPassInCart) {
      throw new Error(DELIVERY_PASS_IN_CART_ERROR)
    }
  }

  return throwIfDeliveryPassExists
}
